import { Text } from "@chakra-ui/react";
import type { TextProps } from "@chakra-ui/react";
import { RatioType } from "common/interfaces/KYDMarketing";

const defaultStyles: TextProps = {
  color: "rgba(26, 32, 44, 0.60)",
  fontFamily: "Work Sans",
  fontStyle: "normal",
  fontWeight: "500",
  lineHeight: "140%",
};

export function RatioLabel({
  type,
  ...textProps
}: { type?: RatioType } & TextProps) {
  const [name, ratio] =
    type === RatioType.square ? ["Square", "1:1"] : ["Vertical", "16:9"];
  return (
    <Text {...defaultStyles} {...textProps}>
      {name}{" "}
      <Text as="span" color={textProps.color ?? defaultStyles.color}>
        {ratio}
      </Text>
    </Text>
  );
}
